import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./styles.module.css";

const SideDrawer = (props) => {
  const {height} = props;
  const [selected, setSelected] = useState("");
  let location = useLocation();

  useEffect(() => {
    let urlsArray = location.pathname.split("/");
    if (urlsArray.length > 1) {
      if (urlsArray.some((urls) => urls.startsWith("gallery"))) {
        setSelected("/gallery");
      } else if (urlsArray.some((urls) => urls === "barchart")) {
        setSelected("/barchart");
      } else if (urlsArray.some((urls) => urls === "horizbar")) {
        setSelected("/horizbar");
      } else if (urlsArray.some((urls) => urls === "stackbar")) {
        setSelected("/stackbar");
      } else if (urlsArray.some((urls) => urls === "candlestick")) {
        setSelected("/candlestick");
      } else if (urlsArray.some((urls) => urls === "linechart")) {
        setSelected("/linechart");
      } else if (urlsArray.some((urls) => urls === "areachart")) {
        setSelected("/areachart");
      } else if (urlsArray.some((urls) => urls === "bubblechart")) {
        setSelected("/bubblechart");
      } else if (urlsArray.some((urls) => urls === "piechart")) {
        setSelected("/piechart");
      } else if (urlsArray.some((urls) => urls === "radarchart")) {
        setSelected("/radarchart");
      } else if (urlsArray.some((urls) => urls === "popnpyramid")) {
        setSelected("/popnpyramid");
      } else {
        setSelected("/");
      }
    } else {
      setSelected("/");
    }
  }, [location.pathname]);

  return (
    <div className={styles.container} style={{ height: height - 60 }}>
      <div className={styles.box}>
        <NavLink
          onClick={() => setSelected("/")}
          className={selected === "/" ? styles.selectedText : styles.text}
          to="/"
        >
          Home
        </NavLink>

        <NavLink
          onClick={() => setSelected("/gallery")}
          className={
            selected === "/gallery" ? styles.selectedText : styles.text
          }
          to="/gallery"
        >
          Gallery
        </NavLink>
      </div>
      <div className={styles.box}>
        <div className={styles.emoji}>📊</div>
        <NavLink
          onClick={() => setSelected("/barchart")}
          className={
            selected === "/barchart" ? styles.selectedText : styles.text
          }
          to="/barchart"
        >
          Bar Chart
        </NavLink>
        <NavLink
          onClick={() => setSelected("/horizbar")}
          className={
            selected === "/horizbar" ? styles.selectedText : styles.text
          }
          to="/horizbar"
        >
          Horizontal Bar
        </NavLink>
        <NavLink
          onClick={() => setSelected("/stackbar")}
          className={
            selected === "/stackbar" ? styles.selectedText : styles.text
          }
          to="/stackbar"
        >
          Stacked Bar
        </NavLink>
        <NavLink
          onClick={() => setSelected("/candlestick")}
          className={
            selected === "/candlestick" ? styles.selectedText : styles.text
          }
          to="/candlestick"
        >
          Candle Stick
        </NavLink>
      </div>
      <div className={styles.box}>
        <div className={styles.emoji}>📈</div>
        <NavLink
          onClick={() => setSelected("/linechart")}
          className={
            selected === "/linechart" ? styles.selectedText : styles.text
          }
          to="/linechart"
        >
          Line Chart
        </NavLink>
        <NavLink
          onClick={() => setSelected("/areachart")}
          className={
            selected === "/areachart" ? styles.selectedText : styles.text
          }
          to="/areachart"
        >
          Area Chart
        </NavLink>
        <NavLink
          onClick={() => setSelected("/bubblechart")}
          className={
            selected === "/bubblechart" ? styles.selectedText : styles.text
          }
          to="/bubblechart"
        >
          Bubble Chart
        </NavLink>
      </div>
      <div className={styles.box}>
        <div className={styles.emoji}>🍰</div>
        <NavLink
          onClick={() => setSelected("/piechart")}
          className={
            selected === "/piechart" ? styles.selectedText : styles.text
          }
          to="/piechart"
        >
          Pie & Donut
        </NavLink>
        <NavLink
          onClick={() => setSelected("/radarchart")}
          className={
            selected === "/radarchart" ? styles.selectedText : styles.text
          }
          to="/radarchart"
        >
          Radar Chart
        </NavLink>
      </div>
      <div className={styles.box}>
        <img
          src={require("../../assets/pyramid.png")}
          className={styles.pyramid}
        />
        <NavLink
          onClick={() => setSelected("/popnpyramid")}
          className={
            selected === "/popnpyramid" ? styles.selectedText : styles.text
          }
          to="/popnpyramid"
        >
          Pyramid
        </NavLink>
      </div>
    </div>
  );
};

export default SideDrawer;
